import React, { useState, useEffect, useContext } from "react";
import { Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import RecruiterFilter from "../UniversalCustomViewCanvas/elements/RecruiterFilter";
import SalesFilter from "../UniversalCustomViewCanvas/elements/SalesFilter";
import ClientFilter from "../UniversalCustomViewCanvas/elements/ClientFilter";
import CountryFilter from "../UniversalCustomViewCanvas/elements/CountryFilter";
import DynamicFormFilter from "../UniversalCustomViewCanvas/elements/DynamicFormFilter";
import {
  // Job Timeline
  setDefaultCustomView,
  unselectReportCustomView, // Use for both job and jobtimeline
  deleteDefaultCustomView,
  // Job
  setJobDefaultCustomView,
  deleteJobDefaultCustomView,
} from "../../../store/report/action";
import { CUSTOM_VIEW_TYPE } from "../UniversalReportConstant";
import { set } from "date-fns";
import { UniversalReportContext } from "../context/UniversalReportProvider";

const ExternalFilter = ({
  // Job Timeline
  customView,
  setCustomView,
  setBubbleExternalFilter,
  defaultCustomView,

  // Job
  jobCustomView,
  setJobCustomView,
  setJobBubbleExternalFilter,
  jobDefaultCustomView,
}) => {
  const { extFilter, setExtFilter } = useContext(UniversalReportContext);
  const dispatch = useDispatch();
  const jobForm = useSelector((state) => state.JobFormReducer.form);
  const selectWidth = "210px";

  const [dropDownState, setDropDownState] = useState({
    client: true,
    recruiter: true,
    sales: true,
    country: true,
    jobType: true,
  });

  const handleFilterChange = (value, filterConfig) => {
    applyJobTimelineFilterChange(value, filterConfig);
  };

  const applyJobTimelineFilterChange = (value, filterConfig) => {
    if (value === "") {
      const newExtFilter = JSON.parse(JSON.stringify(extFilter));
      const filterIndex = newExtFilter?.findIndex(
        (filter) => filter.label === filterConfig?.label
      );
      if (filterIndex !== -1 && filterIndex !== undefined) {
        newExtFilter?.splice(filterIndex, 1);
        setExtFilter(newExtFilter);
        return;
      }
    }
    let newExtFilter = JSON.parse(JSON.stringify(extFilter));
    const filterIndex = newExtFilter?.findIndex(
      (filter) => filter.label === filterConfig?.label
    );
    if (filterIndex !== -1 && filterIndex !== undefined) {
      newExtFilter[filterIndex].value = value;
    } else {
      if (!newExtFilter || newExtFilter.length === 0) {
        newExtFilter = [];
      }
      const filter = {
        label: filterConfig?.label,
        field: filterConfig?.field || "",
        value: value,
        filterType: filterConfig?.filterType || "custom",
        dbDataType: filterConfig?.dbDataType || "normal",
        element: filterConfig?.element || "custom",
        operator: "AND",
      };
      if (filterConfig?.condition) {
        filter.condition = filterConfig.condition;
      }
      newExtFilter.push(filter);
    }
    setExtFilter(newExtFilter);
  };

  const handleDefaultViewSelection = () => {
    // Job Timeline
    dispatch(unselectReportCustomView(CUSTOM_VIEW_TYPE.JOB_UNIVERSAL_REPORT));
    setBubbleExternalFilter(null);
    dispatch(deleteJobDefaultCustomView()); // delete both
    dispatch(deleteDefaultCustomView());
    setCustomView(null);
  };

  const handleDefaultViewSelectionJob = () => {
    dispatch(
      unselectReportCustomView(
        CUSTOM_VIEW_TYPE.JOB_UNIVERSAL_REPORT_JOB_LISTING
      )
    );
    setJobBubbleExternalFilter(null);
    dispatch(deleteJobDefaultCustomView());
    setJobCustomView(null);
  };

  const getValue = (label) => {
    if (extFilter) {
      const filter = extFilter?.find((filter) => filter.label === label);
      return filter?.value;
    }
    return "";
  };

  const getOptionsFromFormSchema = (formSchema, name) => {
    if (formSchema) {
      const options = formSchema.find((schema) => schema.name === name);
      if (options && options.options) {
        return options.options;
      }
    }
    return [];
  };

  const getFilterNumbers = (label) => {
    const value = getValue(label);
    if (!value) return;
    try {
      const valueArray = JSON.parse(value);
      return valueArray.length;
    } catch (e) {
      if (value.includes(",")) {
        return value.split(",").length;
      }
      return 1;
    }
    return 0;
  };

  const labelStyle = {
    borderBottom: "1px solid #D3D3D3",
    padding: "3px",
    borderColor: "#D3D3D3",
  };

  const filterDefaultCustomView = (defaultCustomView, extFilters) => {
    // List of all types of ext filters
    const externalFiltersLabel = [
      "Account Name",
      "Recruiter",
      "Sales Person",
      "Country",
      "Job Type",
      "Job Status",
    ];
    // Remove all the filter if it exists. Find all the ext filters

    if (extFilters && extFilters.length > 0) {
      if (defaultCustomView.filters && defaultCustomView.filters.length == 0) {
        defaultCustomView.filters = extFilters;
      } else {
        externalFiltersLabel.forEach((label) => {
          // Check if this label is in extFilters, if no then remove it from defaultCustomView. But if there is, then edit it
          const extFilter = extFilters.find(
            (extFilter) => extFilter.label === label
          );
          if (extFilter) {
            const filterIndex = defaultCustomView?.filters?.findIndex(
              (filter) => filter.label === extFilter.label
            );
            if (filterIndex !== -1 && filterIndex !== undefined) {
              defaultCustomView.filters[filterIndex].value = extFilter.value;
            } else {
              if (!defaultCustomView.filters) {
                defaultCustomView.filters = [];
              }
              defaultCustomView.filters.push(extFilter);
            }
          } else {
            // Remove from defaultCustomView
            const filterIndex = defaultCustomView?.filters?.findIndex(
              (filter) => filter.label === label
            );
            if (filterIndex !== -1 && filterIndex !== undefined) {
              defaultCustomView.filters.splice(filterIndex, 1);
            }
          }
        });
      }
    } else {
      // Remove all the filter that will be in externalFiltersLabel
      externalFiltersLabel.forEach((label) => {
        const filterIndex = defaultCustomView?.filters?.findIndex(
          (filter) => filter.label === label
        );
        if (filterIndex !== -1 && filterIndex !== undefined) {
          defaultCustomView.filters.splice(filterIndex, 1);
        }
      });
    }
    return defaultCustomView;
  };

  const checkDiffInDefaultCustomViewAndExtFilter = (
    defaultCustomView,
    extFilters
  ) => {
    const externalFiltersLabel = [
      "Account Name",
      "Recruiter",
      "Sales Person",
      "Country",
      "Job Type",
      "Job Status",
    ];
    if (!extFilters) {
      return false;
    }
    if (!defaultCustomView.filters && extFilters.length == 0) {
      return false;
    }
    if (!defaultCustomView.filters && extFilters.length > 0) {
      return true;
    }
    // Get all these filters from defaultCustomView
    const defaultFilters = defaultCustomView.filters.filter((filter) =>
      externalFiltersLabel.includes(filter.label)
    );
    // Check with ext filters if they are same for each filters. If the number is different then return true
    // If number is the same then check through each of it
    if (defaultFilters.length !== extFilters.length) {
      return true;
    }
    for (let i = 0; i < defaultFilters.length; i++) {
      // Value is comma seperated. So the order might be different
      if (defaultFilters[i].value !== extFilters[i].value) {
        return true;
      }
    }
    return false;
  };

  return (
    <div>
      <div className="d-flex gap-2 flex-wrap align-items-end">
        <div
          style={{
            width: "210px",
          }}
        >
          <div
            onClick={() =>
              setDropDownState({
                ...dropDownState,
                client: !dropDownState.client,
              })
            }
            className="d-flex justify-content-between mb-1"
            style={labelStyle}
          >
            <div>
              <span className="fw-semibold">
                Account Name
                {getFilterNumbers("Account Name") > 0 && (
                  <span>{` (${getFilterNumbers("Account Name")})`}</span>
                )}
              </span>
            </div>

            <i
              className={`fw-bold 
             ${
               dropDownState?.client
                 ? "ri-arrow-up-s-line"
                 : "ri-arrow-down-s-line"
             }
                `}
            ></i>
          </div>
          {dropDownState?.client && (
            <ClientFilter
              onChange={(value) => {
                handleFilterChange(value, {
                  label: "Account Name",
                  field: "job.job_submission_data.accountName",
                  dbDataType: "jsonb",
                });
              }}
              value={getValue("Account Name")}
              width={selectWidth}
            />
          )}
        </div>

        <div
          style={{
            width: "210px",
          }}
        >
          <div
            onClick={() =>
              setDropDownState({
                ...dropDownState,
                recruiter: !dropDownState.recruiter,
              })
            }
            className="d-flex justify-content-between mb-1"
            style={labelStyle}
          >
            <span className="fw-semibold">
              Recruiter
              {getFilterNumbers("Recruiter") > 0 && (
                <span>{` (${getFilterNumbers("Recruiter")})`}</span>
              )}
            </span>
            <i
              className={`fw-bold 
             ${
               dropDownState?.recruiter
                 ? "ri-arrow-up-s-line"
                 : "ri-arrow-down-s-line"
             }
                `}
            ></i>
          </div>
          {dropDownState?.recruiter && (
            <RecruiterFilter
              onChange={(value) =>
                handleFilterChange(value, {
                  label: "Recruiter",
                  field: "users.first_name",
                })
              }
              value={getValue("Recruiter")}
              width={selectWidth}
            />
          )}
        </div>

        <div
          style={{
            width: "210px",
          }}
        >
          <div
            onClick={() =>
              setDropDownState({
                ...dropDownState,
                sales: !dropDownState.sales,
              })
            }
            className="d-flex justify-content-between mb-1"
            style={labelStyle}
          >
            <span className="fw-semibold">
              Sales Person
              {getFilterNumbers("Sales Person") > 0 && (
                <span>{` (${getFilterNumbers("Sales Person")})`}</span>
              )}
            </span>
            <i
              className={`fw-bold 
             ${
               dropDownState?.sales
                 ? "ri-arrow-up-s-line"
                 : "ri-arrow-down-s-line"
             }
                `}
            ></i>
          </div>
          {dropDownState?.sales && (
            <SalesFilter
              onChange={(value) =>
                handleFilterChange(value, {
                  label: "Sales Person",
                  field: "job.job_submission_data.accountOwner",
                })
              }
              value={getValue("Sales Person")}
              width={selectWidth}
            />
          )}
        </div>

        <div
          style={{
            width: "210px",
          }}
        >
          <div
            onClick={() =>
              setDropDownState({
                ...dropDownState,
                country: !dropDownState.country,
              })
            }
            className="d-flex justify-content-between mb-1"
            style={labelStyle}
          >
            <span className="fw-semibold">
              Country
              {getFilterNumbers("Country") > 0 && (
                <span>{` (${getFilterNumbers("Country")})`}</span>
              )}
            </span>
            <i
              className={`fw-bold 
             ${
               dropDownState?.country
                 ? "ri-arrow-up-s-line"
                 : "ri-arrow-down-s-line"
             }
                `}
            ></i>
          </div>
          {dropDownState?.country && (
            <CountryFilter
              onChange={(value) =>
                handleFilterChange(value, {
                  label: "Country",
                  field: "job.job_submission_data.country",
                  dbDataType: "jsonb",
                })
              }
              value={getValue("Country")}
              width={selectWidth}
            />
          )}
        </div>

        {/* Job Type */}
        <div
          style={{
            width: "210px",
          }}
        >
          <div
            onClick={() =>
              setDropDownState({
                ...dropDownState,
                jobType: !dropDownState.jobType,
              })
            }
            className="d-flex justify-content-between mb-1"
            style={labelStyle}
          >
            <span className="fw-semibold">
              Job Type
              {getFilterNumbers("Job Type") > 0 && (
                <span>{` (${getFilterNumbers("Job Type")})`}</span>
              )}
            </span>
            <i
              className={`fw-bold 
             ${
               dropDownState?.jobType
                 ? "ri-arrow-up-s-line"
                 : "ri-arrow-down-s-line"
             }
                `}
            ></i>
          </div>
          {dropDownState?.jobType && (
            <DynamicFormFilter
              onChange={(value) =>
                handleFilterChange(value, {
                  label: "Job Type",
                  field: "job.job_submission_data.jobType",
                  dbDataType: "jsonb",
                  filterType: "custom",
                  condition: "In",
                })
              }
              value={getValue("Job Type")}
              width={selectWidth}
              dataSet={getOptionsFromFormSchema(jobForm?.formSchema, "jobType")}
              placeholder="Select Job Type"
            />
          )}
        </div>

        {/* Job Status */}
        <div
          style={{
            width: "210px",
          }}
        >
          <div
            onClick={() =>
              setDropDownState({
                ...dropDownState,
                jobType: !dropDownState.jobType,
              })
            }
            className="d-flex justify-content-between mb-1"
            style={labelStyle}
          >
            <span className="fw-semibold">
              Job Status
              {getFilterNumbers("Job Status") > 0 && (
                <span>{` (${getFilterNumbers("Job Status")})`}</span>
              )}
            </span>
            <i
              className={`fw-bold 
             ${
               dropDownState?.jobType
                 ? "ri-arrow-up-s-line"
                 : "ri-arrow-down-s-line"
             }
                `}
            ></i>
          </div>
          {dropDownState?.jobType && (
            <DynamicFormFilter
              onChange={(value) =>
                handleFilterChange(value, {
                  label: "Job Status",
                  field: "job.job_submission_data.jobStatus",
                  dbDataType: "jsonb",
                  filterType: "custom",
                  condition: "In",
                })
              }
              value={getValue("Job Status")}
              width={selectWidth}
              dataSet={getOptionsFromFormSchema(
                jobForm?.formSchema,
                "jobStatus"
              )}
              placeholder="Select Job Status"
            />
          )}
        </div>
        <div>
          <Button
            style={{
              backgroundColor: "#0A56AE",
              color: "#fff",
            }}
            onClick={() => {
              let newDefaultCustomView = JSON.parse(
                JSON.stringify(defaultCustomView)
              );
              let newJobDefaultCustomView = JSON.parse(
                JSON.stringify(jobDefaultCustomView)
              );

              if (customView && customView != -1) {
                handleDefaultViewSelection();
              }
              if (jobCustomView && jobCustomView != -1) {
                handleDefaultViewSelectionJob();
              }

              // If you want to overwrite the existing filters
              // newDefaultCustomView.filters = extFilter;
              // newJobDefaultCustomView.filters = extFilter;

              setBubbleExternalFilter(null);
              setJobBubbleExternalFilter(null);

              newDefaultCustomView = filterDefaultCustomView(
                newDefaultCustomView,
                extFilter
              );
              newJobDefaultCustomView = filterDefaultCustomView(
                newJobDefaultCustomView,
                extFilter
              );

              dispatch(setDefaultCustomView(newDefaultCustomView));
              dispatch(setJobDefaultCustomView(newJobDefaultCustomView));
            }}
            disabled={
              !checkDiffInDefaultCustomViewAndExtFilter(
                defaultCustomView,
                extFilter
              )
            }
          >
            Filter
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExternalFilter;
